module.exports = __webpack_public_path__ + "img/banner-principal.b703a25a.png";